import React, { ChangeEvent } from 'react';
import { v4 as uuid } from 'uuid';
import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { appActions } from '../../../../../base/redux/slices/appSlice';
import { __t } from '../../../../../base/utils/t';
import { IMAGE_MAX_UPLOAD_SIZE, IMAGE_UPLOAD_ALLOWED_FILE_TYPES } from '../../../../constants';
import { profileActions } from '../../redux/slice/profileSlice';

import './styles.scss';

export const LogoUpload = () => {
    const dispatch = useAppDispatch();
    const { imageUrl } = useAppSelector((state) => state.recruiterAppProfile.fields);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        handleFiles(e.target.files);
        e.target.value = '';
    };

    const validateFile = (file: File): string => {
        if (!IMAGE_UPLOAD_ALLOWED_FILE_TYPES.includes(file.type)) {
            return `${__t(
                'Тип файла не поддерживается. Поддерживаемые типы:',
            )} ${IMAGE_UPLOAD_ALLOWED_FILE_TYPES.join()}`;
        }

        if (file.size > IMAGE_MAX_UPLOAD_SIZE) {
            return `${__t('Нельзя загружать файлы более')} ${IMAGE_MAX_UPLOAD_SIZE / 1000000}Mb`;
        }

        return '';
    };

    const handleFiles = (fileList: FileList | null): void => {
        if (!fileList) return;
        const file = fileList[0];
        const validationError = validateFile(file);
        if (validationError) {
            dispatch(
                appActions.enqueueSnackbar({
                    id: uuid(),
                    message: validationError,
                    title: file.name,
                    icon: 'triangle-exclamation-duonote-red',
                    iconColor: 'danger',
                }),
            );
        } else {
            dispatch(profileActions.uploadLogo(file));
        }
    };

    const handleDelete = () => {
        dispatch(profileActions.setField({ id: 'imageUrl', value: null }));
        dispatch(profileActions.setField({ id: 'image', value: null }));
    };

    return (
        <div className='logo-upload'>
            <div className='logo-upload__preview'>
                {imageUrl ? (
                    <>
                        <img src={imageUrl} />
                        <div className='logo-upload__delete-logo-button' onClick={handleDelete}>
                            <Icon icon='trash-can-regular' color='white' />
                        </div>
                    </>
                ) : (
                    <Icon icon='building-duonote' size='56' />
                )}
            </div>
            <div className='logo-upload__content'>
                {!imageUrl && 
                    <p className='logo-upload__description'>
                        {__t('Компании без логотипа получают меньше просмотров и приглашений к сотрудничеству. ')}
                    </p>}
                <label htmlFor='logo-upload' className='logo-upload__label'>
                    <input id='logo-upload' type='file' className='logo-upload__hidden-input' onChange={handleChange} />
                    <div style={{ pointerEvents: 'none' }}>
                        <Button type='secondary' className='logo-upload__button'>
                            {__t('Загрузить файл')}
                        </Button>
                    </div>
                </label>
            </div>
        </div>
    );
};
